'use strict';

angular.module('myConsultApp').factory('IdentityService', function ($resource, ENV, Session) {
  var identityService = {};

  var user = '';

  var selectUserPets = null;

  var selectedUserRoute = null;

  var recentCreatedPetId = null;

  identityService.check = function () {
    var user = $resource(
      ENV.apiEndpoint + '/1.0/me/',
      {},
      { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    return user.get().$promise.then(function (response) {
      return response.data;
    });
  };

  identityService.getClientInfo = function (str) {
    var owners = $resource(
      ENV.apiEndpoint + '/1.0/user-search/',
      {},
      {
        get: {
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return owners.get({ search: str }).$promise.then(function (response) {
      return response;
    });
  };

  identityService.getClientInfoPage = function (str) {
    var owners = $resource(
      str,
      {},
      {
        get: {
          headers: { Authorization: 'Bearer ' + Session.accessToken },
        },
      },
    );

    return owners.get().$promise.then(function (response) {
      return response;
    });
  };
  identityService.updateUserInfo = function (userid, data) {
    var userInfo = $resource(
      ENV.apiEndpoint + '/1.0/identities/' + userid + '/',
      {},
      { update: { method: 'PUT', headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    return userInfo.update(data).$promise.then(function (response) {
      return response;
    });
  };

  identityService.getUser = function (id) {
    var user = $resource(
      ENV.apiEndpoint + '/1.0/identities/:id/',
      { id: id },
      { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    return user.get().$promise.then(function (response) {
      return response.identity;
    });
  };

  identityService.getUserSync = function (id) {
    var user = $resource(
      ENV.apiEndpoint + '/1.0/identities/:id/?sync_identity_data=true',
      { id: id },
      { get: { headers: { Authorization: 'Bearer ' + Session.accessToken } } },
    );

    return user.get().$promise.then(function (response) {
      return response.identity;
    });
  };

  identityService.storeUser = function (uservalue) {
    user = uservalue;
    return user;
  };

  identityService.getStoredUser = function () {
    return user;
  };

  identityService.storeSelectUserPets = function (info, routepath) {
    selectedUserRoute = routepath;
    selectUserPets = info;
    return selectUserPets;
  };

  identityService.getstoreSelectUserPets = function () {
    return selectUserPets;
  };

  identityService.getSelectedUsersPath = function () {
    return selectedUserRoute;
  };

  identityService.setRecentCreatedPetId = function (petid) {
    recentCreatedPetId = petid;
    return recentCreatedPetId;
  };

  identityService.getRecentCreatedPetId = function () {
    return recentCreatedPetId;
  };

  return identityService;
});
